module.exports = __webpack_public_path__ + "static/mr-concert-performance-10-1eed8699c70d4d4437b62d7ae3878f36.jpg";